import { ReactNode } from 'react';
import { ApolloProvider } from '@apollo/client/react';
import { graphqlClient } from '@core/api/graphqlClient';
import { CartProvider } from '@features/cart/context/CartContext';
import { AuthProvider } from '@features/auth/context/AuthContext';
import { WishlistProvider } from '@features/wishlist/context/WishlistContext';

interface AppProviderProps {
  children: ReactNode;
}

/**
 * Main app provider component
 * Add global providers here (Theme, Auth, State Management, etc.)
 */
export const AppProvider = ({ children }: AppProviderProps) => {
  return (
    <ApolloProvider client={graphqlClient}>
      <AuthProvider>
        <CartProvider>
          <WishlistProvider>
            {children}
          </WishlistProvider>
        </CartProvider>
      </AuthProvider>
    </ApolloProvider>
  );
};

